import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { bsc} from 'wagmi/chains'


const projectId = '27b9720018bf7f8740936e6a6eb28604'
const metadata = {
  name: 'Web3Modal',
  description: 'Web3Modal Example',
  url: 'https://web3modal.com',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

const chains = [bsc]
export const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata })


createWeb3Modal({
  wagmiConfig,
  projectId,
  chains,
  enableAnalytics: true
})